import request from '@/util/request'

const api = {
  user: '/user',
  service: '/service',
  orgTree: '/org/tree',
  publicApi: 'http://wysgw.lylcc.com'//http://gw.wyschina.com  http://wysgw.lylcc.com
}

export default api


// 新的目录分页
export function getOpenMenu (current, pageSize,type) {
  return request({
    url: '/menu/open/page',
    method: 'post',
    params: {
      current: current,
      pageSize: pageSize,
      type:type,
      pId:0
    }
  })
}
// 新的目录分页点击量
export function getOpenAddHits(id) {
  return request({
    url: `/menu/open/hits/${id}`,
    method: 'get',
  })
}



//景区概括（供web小程序）
export function aboutInfoHitsById (id) {
  return request({
    // /api/manage/aboutInfo/open/hits/{id}
    url: `/aboutInfo/open/hits/${id}`,
    method: 'get',
  })
}
//公告点击量添加（供web小程序）
export function noticeInfoHitsById (id) {
  return request({
    // /api/manage/aboutInfo/open/hits/{id}
    url: `/notice/open/hits/${id}`,
    method: 'get',
  })
}

// 当地美食
export function getFoodLocal (current, pageSize) {
  return request({
    url: '/foodLocal/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//美食推荐
export function getFoodRecommend (current, pageSize) {
  return request({
    url: '/foodRecommend/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//美食特色美食
export function getFoodCharacteristic (current, pageSize) {
  return request({
    url: '/foodCharacteristic/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}


// 当地特产
export function getSpecialtyLocal (current, pageSize) {
  return request({
    url: '/specialtyLocal/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//特产推荐
export function getSpecialtyRecommend (current, pageSize) {
  return request({
    url: '/specialtyRecommend/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//纪念品
export function getSpecialtySouvenir (current, pageSize) {
  return request({
    url: '/specialtySouvenir/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}

//景区风景
export function getAboutSpotList () {
  return request({
    url: '/aboutSpot/open/list',
    method: 'get'
  })
}


//景区风景
export function getAboutSpot (current, pageSize) {
  return request({
    url: '/aboutSpot/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}



//景区景点点击
export function getAboutSpotById (id) {
  return request({
    url: `/aboutSpot/open/hits/${id}`,
    method: 'get',
  })
}


//美食当地点击量 /api/manage/foodLocal/open/hits/{id}
export function getFoodLocalById (id) {
  return request({
    url: `/foodLocal/open/hits/${id}`,
    method: 'get',
  })
}

//推荐美食 /api/manage/foodLocal/open/hits/{id}
export function getFoodRecommendById (id) {
  return request({
    url: `/foodRecommend/open/hits/${id}`,
    method: 'get',
  })
}
//特色美食/api/manage/foodCharacteristic/open/hits/{id}
export function getFoodCharacteristicById (id) {
  return request({
    url: `/foodCharacteristic/open/hits/${id}`,
    method: 'get',
  })
}



//特产当地点击
export function getSpecialtyLocalById (id) {
  return request({
    url: `/specialtyLocal/open/hits/${id}`,
    method: 'get',
  })
}

//特产推荐
export function getSpecialtyRecommendById (id) {
  return request({
    url: `/specialtyRecommend/open/hits/${id}`,
    method: 'get',
  })
}
//纪念品
export function getSpecialtySouvenirById (id) {
  return request({
    url: `/specialtySouvenir/open/hits/${id}`,
    method: 'get',
  })
}

//武夷山规划点击量
export function getAboutPlanById (id) {
  return request({
    url: `/aboutPlan/open/hits/${id}`,
    method: 'get',
  })
}
//武夷山规划
export function getAboutPlan (current, pageSize) {
  return request({
    url: '/aboutPlan/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}



//地址演变点击量
export function getAboutAreaById (id) {
  return request({
    url: `/aboutArea/open/hits/${id}`,
    method: 'get',
  })
}
//武夷山地址演变
export function getAboutArea (current, pageSize) {
  return request({
    url: '/aboutArea/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}



//KTV
export function getEntertainmentKtv (current, pageSize) {
  return request({
    url: '/entertainmentKtv/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//野战
export function getEntertainmentPaintball (current, pageSize) {
  return request({
    url: '/entertainmentPaintball/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//演出
export function getEntertainmentShow (current, pageSize) {
  return request({
    url: '/entertainmentShow/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}

//高尔夫
export function getEntertainmentGolf (current, pageSize) {
  return request({
    url: '/entertainmentGolf/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}



//KTV点击
export function getEntertainmentKtvById (id) {
  return request({
    url: `/entertainmentKtv/open/hits/${id}`,
    method: 'get',
  })
}
//野战
export function getEntertainmentPaintballById (id) {
  return request({
    url: `/entertainmentPaintball/open/hits/${id}`,
    method: 'get',
  })
}
//演出
export function getEntertainmentShowById (id) {
  return request({
    url: `/entertainmentShow/open/hits/${id}`,
    method: 'get',
  })
}
//高尔夫
export function getEntertainmentGolfById (id) {
  return request({
    url: `/entertainmentGolf/open/hits/${id}`,
    method: 'get',
  })
}




//党的思想
export function getPartyThought (current, pageSize) {
  return request({
    url: '/partyThought/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//党的历史
export function getPartyHistory (current, pageSize) {
  return request({
    url: '/partyHistory/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}


//党的历史点击
export function getPartyHistoryById (id) {
  return request({
    url: `/partyHistory/open/hits/${id}`,
    method: 'get',
  })
}
//党的思想的点击
export function getPartyThoughtById (id) {
  return request({
    url: `/partyThought/open/hits/${id}`,
    method: 'get',
  })
}


//旅游新闻
export function getNewsTravel (current, pageSize) {
  return request({
    url: '/newsTravel/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//旅游新闻点击
export function getNewsTravelById (id) {
  return request({
    url: `/newsTravel/open/hits/${id}`,
    method: 'get',
  })
}


//景区新闻
export function getNewsScenic (current, pageSize) {
  return request({
    url: '/newsScenic/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}
//景区新闻点击
export function getNewsScenicById (id) {
  return request({
    url: `/newsScenic/open/hits/${id}`,
    method: 'get',
  })
}


//星级酒店
export function getHotelStar (current, pageSize) {
  return request({
    url: '/hotelStar/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}


//星际酒店分页列表
export function getHotelList1 (current, pageSize) {
  return request({
    url: '/hotelStar/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}

//经济酒店分页列表  /api/manage/hotelCharacteristic/manage/pages
export function getHotelList2 (current, pageSize) {
  return request({
    url: '/hotelEconomy/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}

//特色名宿分页列表
export function getHotelList3 (current, pageSize) {
  return request({
    url: '/hotelCharacteristic/open/pages',
    method: 'get',
    params: {
      current: current,
      pageSize: pageSize
    }
  })
}

//轮播图获取
export function getBannerList (type) {
  return request({
    url: '/home/open/list',
    method: 'get',
    params: {
      'type': type
    }
  })
}
//概况走进武夷山
export function getAboutInfo () {
  return request({
    url: '/aboutInfo/open/list',
    method: 'get',
  })
}
//飞机航班 /api/manage/trafficPlane/open/list
export function getTrafficPlane () {
  return request({
    url: '/trafficPlane/open/list',
    method: 'get',
  })
}
export function getTrafficPlaneHits (id) {
  return request({
    url: `/trafficPlane/open/hits/${id}`,
    method: 'get',
  })
}

//火车时刻
export function getTrafficTrain () {
  return request({
    url: '/trafficTrain/open/list',
    method: 'get',
  })
}
export function gettTrafficTrainHits (id) {
  return request({
    url: `/trafficTrain/open/hits/${id}`,
    method: 'get',
  })
}


//汽车班次
export function getTrafficBus () {
  return request({
    url: '/trafficBus/open/list',
    method: 'get',
  })
}
export function getTrafficBusHits (id) {
  return request({
    url: `/trafficBus/open/hits/${id}`,
    method: 'get',
  })
}


//自驾路线
export function getTrafficDrive () {
  return request({
    url: '/trafficDrive/open/list',
    method: 'get',
  })
}
export function getTrafficDriveHits (id) {
  return request({
    url: `/trafficDrive/open/hits/${id}`,
    method: 'get',
  })
}

//导游列表
export function getGuideList (current, pageSize, level) {
  return request({
    url: '/guide/open/pages',
    method: 'get',
    params: {
      'current': current,
      'pageSize': pageSize,
      'level': level
    }
  })
}
//链接列表/api/manage/link/open/list
export function getLinkList () {
  return request({
    url: '/link/open/list',
    method: 'get',
  })
}

//专栏
export function getNationalList (type) {
  return request({
    url: '/notice/open/list',
    method: 'get',
    params:{
      type:type
    }

  })
}

//公告链接获取
export function getNoticeList () {
  return request({
    url: '/notice/open/list',
    method: 'get'
  })
}

//底部菜单
export function getBottomList () {
  return request({
    url: '/bottom/open/list',
    method: 'get',
  })
}
//实时数据
export function getRealTimeData (data) {
  return request({
    url: 'https://piaowu.wyschina.com/gateway/applet/raft/ticket/real-time-forecast',
    method: 'post',
    data:data
  })
}
//公告
export function getEffectiveNotice (data) {
  return request({
    url: 'https://piaowu.wyschina.com/gateway/bms/merch/article/get-effective-notice',
    method: 'post',
    data:data
  })
}
//茶文化 分页开放
export function getMenuOpenList (pId,type,current,pageSize) {
  return request({
    url: '/menu/open/page',
    method: 'post',
    params:{
      pId:pId,
      type:type,
      current:current,
      pageSize:pageSize
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js